import { render } from "./2021-07-05-Blog3.md?vue&type=template&id=42be08cf"
const script = {}
script.render = render

export default script